import { createFileRoute } from '@tanstack/react-router';
import { AcceptInvitationPage } from '../features/auth/AcceptInvitationPage.jsx';

// Outside the signed-in layout (_app): the person accepting is not platform staff until they accept.
export const Route = createFileRoute('/accept-invitation')({ component: AcceptInvitationPage });
